// proto/v2/research/research.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file research/research.proto (package lvdr.v2.research, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { PaginationParams, SortParams, SourceCitation } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { ResearchFailureSummary } from "../execution/execution_pb";
import { file_execution_execution } from "../execution/execution_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file research/research.proto.
 */
export const file_research_research: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_common, file_execution_execution]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.research.CreateResearchRequest
 */
export type CreateResearchRequest = Message<"lvdr.v2.research.CreateResearchRequest"> & {
  /**
   * @generated from field: string goal = 1;
   */
  goal: string;

  /**
   * @generated from field: double budget = 2;
   */
  budget: number;

  /**
   * @generated from field: string profile = 3;
   */
  profile: string;

  /**
   * @generated from field: string report_style = 4;
   */
  reportStyle: string;

  /**
   * Diagram enhancement seed values (Phase 8). When omitted, the server
   * falls back to the user-settings seed (`diagram_enhancement_enabled`)
   * and the default preset. Override is capped to 500 chars at the
   * boundary; longer values are silently truncated.
   *
   * @generated from field: string diagram_style = 5;
   */
  diagramStyle: string;

  /**
   * @generated from field: string diagram_style_override = 6;
   */
  diagramStyleOverride: string;

  /**
   * @generated from field: bool diagram_enhancement_on = 7;
   */
  diagramEnhancementOn: boolean;

  /**
   * Research-in-Workspace (E1): when set, the run executes in the creator's
   * personal area and auto-files (moves) into this Workspace
   * on successful completion. Must equal the session's ACTIVE workspace and
   * the caller must hold read_write — the server rejects anything else.
   * Empty = personal run (no filing).
   *
   * @generated from field: string workspace_id = 8;
   */
  workspaceId: string;

  /**
   * R8 i18n Phase 2: explicit output language for generated prose
   * (BCP-47, e.g. "de" or "de-de"). Empty = not set — the server resolves
   * via user locale → enricher language detection → English.
   *
   * @generated from field: string output_language = 9;
   */
  outputLanguage: string;
};

/**
 * Describes the message lvdr.v2.research.CreateResearchRequest.
 * Use `create(CreateResearchRequestSchema)` to create a new message.
 */
export const CreateResearchRequestSchema: GenMessage<CreateResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 0);

/**
 * @generated from message lvdr.v2.research.UpdateResearchRequest
 */
export type UpdateResearchRequest = Message<"lvdr.v2.research.UpdateResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string goal = 2;
   */
  goal: string;

  /**
   * @generated from field: double budget = 3;
   */
  budget: number;

  /**
   * @generated from field: string title = 4;
   */
  title: string;
};

/**
 * Describes the message lvdr.v2.research.UpdateResearchRequest.
 * Use `create(UpdateResearchRequestSchema)` to create a new message.
 */
export const UpdateResearchRequestSchema: GenMessage<UpdateResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 1);

/**
 * RegenerateResearchTitleRequest asks the server to produce a FRESH LLM title
 * candidate WITHOUT persisting it. The client previews the candidate in the
 * rename dialog and commits it via UpdateResearchRequest (which pins the title
 * so background auto-generation can no longer overwrite it).
 *
 * @generated from message lvdr.v2.research.RegenerateResearchTitleRequest
 */
export type RegenerateResearchTitleRequest = Message<"lvdr.v2.research.RegenerateResearchTitleRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.RegenerateResearchTitleRequest.
 * Use `create(RegenerateResearchTitleRequestSchema)` to create a new message.
 */
export const RegenerateResearchTitleRequestSchema: GenMessage<RegenerateResearchTitleRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 2);

/**
 * RegenerateResearchTitleResponse carries the unsaved candidate title.
 * research_id is echoed so the client can correlate the response to the
 * originating request.
 *
 * @generated from message lvdr.v2.research.RegenerateResearchTitleResponse
 */
export type RegenerateResearchTitleResponse = Message<"lvdr.v2.research.RegenerateResearchTitleResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string candidate_title = 2;
   */
  candidateTitle: string;
};

/**
 * Describes the message lvdr.v2.research.RegenerateResearchTitleResponse.
 * Use `create(RegenerateResearchTitleResponseSchema)` to create a new message.
 */
export const RegenerateResearchTitleResponseSchema: GenMessage<RegenerateResearchTitleResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 3);

/**
 * @generated from message lvdr.v2.research.DeleteResearchRequest
 */
export type DeleteResearchRequest = Message<"lvdr.v2.research.DeleteResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.DeleteResearchRequest.
 * Use `create(DeleteResearchRequestSchema)` to create a new message.
 */
export const DeleteResearchRequestSchema: GenMessage<DeleteResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 4);

/**
 * @generated from message lvdr.v2.research.GetResearchRequest
 */
export type GetResearchRequest = Message<"lvdr.v2.research.GetResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.GetResearchRequest.
 * Use `create(GetResearchRequestSchema)` to create a new message.
 */
export const GetResearchRequestSchema: GenMessage<GetResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 5);

/**
 * @generated from message lvdr.v2.research.ListResearchRequest
 */
export type ListResearchRequest = Message<"lvdr.v2.research.ListResearchRequest"> & {
  /**
   * @generated from field: lvdr.v2.common.PaginationParams pagination = 1;
   */
  pagination?: PaginationParams | undefined;

  /**
   * @generated from field: lvdr.v2.common.SortParams sort = 2;
   */
  sort?: SortParams | undefined;
};

/**
 * Describes the message lvdr.v2.research.ListResearchRequest.
 * Use `create(ListResearchRequestSchema)` to create a new message.
 */
export const ListResearchRequestSchema: GenMessage<ListResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 6);

/**
 * @generated from message lvdr.v2.research.SubscribeResearchRequest
 */
export type SubscribeResearchRequest = Message<"lvdr.v2.research.SubscribeResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.SubscribeResearchRequest.
 * Use `create(SubscribeResearchRequestSchema)` to create a new message.
 */
export const SubscribeResearchRequestSchema: GenMessage<SubscribeResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 7);

/**
 * @generated from message lvdr.v2.research.UnsubscribeResearchRequest
 */
export type UnsubscribeResearchRequest = Message<"lvdr.v2.research.UnsubscribeResearchRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.UnsubscribeResearchRequest.
 * Use `create(UnsubscribeResearchRequestSchema)` to create a new message.
 */
export const UnsubscribeResearchRequestSchema: GenMessage<UnsubscribeResearchRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 8);

/**
 * @generated from message lvdr.v2.research.SubscribeResearchListRequest
 */
export type SubscribeResearchListRequest = Message<"lvdr.v2.research.SubscribeResearchListRequest"> & {
};

/**
 * Describes the message lvdr.v2.research.SubscribeResearchListRequest.
 * Use `create(SubscribeResearchListRequestSchema)` to create a new message.
 */
export const SubscribeResearchListRequestSchema: GenMessage<SubscribeResearchListRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 9);

/**
 * @generated from message lvdr.v2.research.UnsubscribeResearchListRequest
 */
export type UnsubscribeResearchListRequest = Message<"lvdr.v2.research.UnsubscribeResearchListRequest"> & {
};

/**
 * Describes the message lvdr.v2.research.UnsubscribeResearchListRequest.
 * Use `create(UnsubscribeResearchListRequestSchema)` to create a new message.
 */
export const UnsubscribeResearchListRequestSchema: GenMessage<UnsubscribeResearchListRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 10);

/**
 * @generated from message lvdr.v2.research.GenerateSummaryRequest
 */
export type GenerateSummaryRequest = Message<"lvdr.v2.research.GenerateSummaryRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.GenerateSummaryRequest.
 * Use `create(GenerateSummaryRequestSchema)` to create a new message.
 */
export const GenerateSummaryRequestSchema: GenMessage<GenerateSummaryRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 11);

/**
 * @generated from message lvdr.v2.research.GetResearchResultRequest
 */
export type GetResearchResultRequest = Message<"lvdr.v2.research.GetResearchResultRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.GetResearchResultRequest.
 * Use `create(GetResearchResultRequestSchema)` to create a new message.
 */
export const GetResearchResultRequestSchema: GenMessage<GetResearchResultRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 12);

/**
 * @generated from message lvdr.v2.research.ResearchResultResponse
 */
export type ResearchResultResponse = Message<"lvdr.v2.research.ResearchResultResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string output = 3;
   */
  output: string;

  /**
   * @generated from field: double total_cost = 4;
   */
  totalCost: number;

  /**
   * @generated from field: int32 node_count = 5;
   */
  nodeCount: number;

  /**
   * @generated from field: int64 duration_ms = 6;
   */
  durationMs: bigint;

  /**
   * @generated from field: repeated lvdr.v2.common.SourceCitation citations = 7;
   */
  citations: SourceCitation[];

  /**
   * @generated from field: int32 total_tokens_in = 8;
   */
  totalTokensIn: number;

  /**
   * @generated from field: int32 total_tokens_out = 9;
   */
  totalTokensOut: number;

  /**
   * @generated from field: bool error_dismissed = 10;
   */
  errorDismissed: boolean;

  /**
   * @generated from field: lvdr.v2.execution.ResearchFailureSummary failure_summary = 11;
   */
  failureSummary?: ResearchFailureSummary | undefined;

  /**
   * @generated from field: int32 max_depth = 12;
   */
  maxDepth: number;

  /**
   * @generated from field: int32 sources_searched = 13;
   */
  sourcesSearched: number;

  /**
   * Word count of the assembled report markdown — surfaced in the research
   * detail toolbar and as the basis for reading_time_minutes.
   *
   * @generated from field: int32 word_count = 14;
   */
  wordCount: number;

  /**
   * Estimated reading time in whole minutes (200 wpm baseline). Always at
   * least 1 when word_count > 0 so we don't show "0 min read".
   *
   * @generated from field: int32 reading_time_minutes = 15;
   */
  readingTimeMinutes: number;

  /**
   * Topology counters for the complexity badge. Populated at GetResearchStats
   * backfill time. Old records (pre-this-field) deserialise with all zeros.
   *
   * @generated from field: lvdr.v2.research.ComplexityCounts complexity_counts = 16;
   */
  complexityCounts?: ComplexityCounts | undefined;

  /**
   * Total sources evaluated by the reranker across the run (Σ ranked results,
   * not deduped — mirrors sources_searched accumulation). The denominator for
   * the completed-state "N of M sources cited" display; lets it survive a cold
   * reload after the live sourceEvaluations map is gone. Old records (pre-this-
   * field) deserialise as 0 → FE renders "N sources cited" without a denominator.
   *
   * @generated from field: int32 sources_evaluated = 17;
   */
  sourcesEvaluated: number;

  /**
   * result_provenance records how `output` was selected so the FE can refuse to
   * render a reconstructed stub as a report. CANONICAL = the run's real report;
   * FALLBACK_SCAN = salvaged the deepest synthesis node after a nil root;
   * SALVAGED_PARTIAL = the salvaged output is placeholder-only. Empty on old
   * records deserialises as CANONICAL behavior (FE treats "" as canonical).
   *
   * @generated from field: string result_provenance = 18;
   */
  resultProvenance: string;
};

/**
 * Describes the message lvdr.v2.research.ResearchResultResponse.
 * Use `create(ResearchResultResponseSchema)` to create a new message.
 */
export const ResearchResultResponseSchema: GenMessage<ResearchResultResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 13);

/**
 * ComplexityCounts captures the topology of a V3 research run for the
 * post-run complexity badge. Counts are derived from persisted node
 * metadata (block_id) at GetResearchStats time. Zero values are valid
 * (e.g. quick_search has no deepening rounds); the FE drops zero-valued
 * chips so the badge degrades cleanly per strategy.
 *
 * @generated from message lvdr.v2.research.ComplexityCounts
 */
export type ComplexityCounts = Message<"lvdr.v2.research.ComplexityCounts"> & {
  /**
   * distinct sub-topic investigations (dim_research + lead_dimensions + gap_search fan-outs)
   *
   * @generated from field: int32 angles = 1;
   */
  angles: number;

  /**
   * 0/1/2: bool(deepen_dimensions fired) + bool(deepen_dims_r2 fired)
   *
   * @generated from field: int32 deepening_rounds = 2;
   */
  deepeningRounds: number;

  /**
   * lead_dimensions completed
   *
   * @generated from field: int32 leads_chased = 3;
   */
  leadsChased: number;

  /**
   * resolve_tensions completed
   *
   * @generated from field: int32 tensions_resolved = 4;
   */
  tensionsResolved: number;

  /**
   * distinct eTLD+1 across final report citations
   *
   * @generated from field: int32 distinct_domains = 5;
   */
  distinctDomains: number;
};

/**
 * Describes the message lvdr.v2.research.ComplexityCounts.
 * Use `create(ComplexityCountsSchema)` to create a new message.
 */
export const ComplexityCountsSchema: GenMessage<ComplexityCounts> = /*@__PURE__*/
  messageDesc(file_research_research, 14);

/**
 * @generated from message lvdr.v2.research.GetResearchAppendixRequest
 */
export type GetResearchAppendixRequest = Message<"lvdr.v2.research.GetResearchAppendixRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.GetResearchAppendixRequest.
 * Use `create(GetResearchAppendixRequestSchema)` to create a new message.
 */
export const GetResearchAppendixRequestSchema: GenMessage<GetResearchAppendixRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 15);

/**
 * @generated from message lvdr.v2.research.AppendixNode
 */
export type AppendixNode = Message<"lvdr.v2.research.AppendixNode"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string task_id = 2;
   */
  taskId: string;

  /**
   * @generated from field: string goal = 3;
   */
  goal: string;

  /**
   * @generated from field: string output = 4;
   */
  output: string;

  /**
   * @generated from field: string agent_type = 5;
   */
  agentType: string;

  /**
   * @generated from field: int32 depth = 6;
   */
  depth: number;

  /**
   * @generated from field: string parent_id = 7;
   */
  parentId: string;

  /**
   * @generated from field: repeated string breadcrumb = 8;
   */
  breadcrumb: string[];

  /**
   * @generated from field: repeated lvdr.v2.common.SourceCitation citations = 9;
   */
  citations: SourceCitation[];

  /**
   * @generated from field: string status = 10;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.research.AppendixNode.
 * Use `create(AppendixNodeSchema)` to create a new message.
 */
export const AppendixNodeSchema: GenMessage<AppendixNode> = /*@__PURE__*/
  messageDesc(file_research_research, 16);

/**
 * @generated from message lvdr.v2.research.ResearchAppendixResponse
 */
export type ResearchAppendixResponse = Message<"lvdr.v2.research.ResearchAppendixResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.research.AppendixNode nodes = 2;
   */
  nodes: AppendixNode[];

  /**
   * @generated from field: int32 total_nodes = 3;
   */
  totalNodes: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchAppendixResponse.
 * Use `create(ResearchAppendixResponseSchema)` to create a new message.
 */
export const ResearchAppendixResponseSchema: GenMessage<ResearchAppendixResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 17);

/**
 * @generated from message lvdr.v2.research.GetResearchStatsRequest
 */
export type GetResearchStatsRequest = Message<"lvdr.v2.research.GetResearchStatsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.GetResearchStatsRequest.
 * Use `create(GetResearchStatsRequestSchema)` to create a new message.
 */
export const GetResearchStatsRequestSchema: GenMessage<GetResearchStatsRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 18);

/**
 * @generated from message lvdr.v2.research.ResearchStatsResponse
 */
export type ResearchStatsResponse = Message<"lvdr.v2.research.ResearchStatsResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 total_nodes = 2;
   */
  totalNodes: number;

  /**
   * @generated from field: int32 completed_nodes = 3;
   */
  completedNodes: number;

  /**
   * @generated from field: int32 failed_nodes = 4;
   */
  failedNodes: number;

  /**
   * @generated from field: double total_cost_usd = 5;
   */
  totalCostUsd: number;

  /**
   * @generated from field: int32 total_tokens_in = 6;
   */
  totalTokensIn: number;

  /**
   * @generated from field: int32 total_tokens_out = 7;
   */
  totalTokensOut: number;

  /**
   * @generated from field: int64 duration_ms = 8;
   */
  durationMs: bigint;

  /**
   * @generated from field: int32 word_count = 9;
   */
  wordCount: number;

  /**
   * @generated from field: int32 reading_time_minutes = 10;
   */
  readingTimeMinutes: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchStatsResponse.
 * Use `create(ResearchStatsResponseSchema)` to create a new message.
 */
export const ResearchStatsResponseSchema: GenMessage<ResearchStatsResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 19);

/**
 * @generated from message lvdr.v2.research.SetResearchReferenceRequest
 */
export type SetResearchReferenceRequest = Message<"lvdr.v2.research.SetResearchReferenceRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: bool is_reference = 2;
   */
  isReference: boolean;
};

/**
 * Describes the message lvdr.v2.research.SetResearchReferenceRequest.
 * Use `create(SetResearchReferenceRequestSchema)` to create a new message.
 */
export const SetResearchReferenceRequestSchema: GenMessage<SetResearchReferenceRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 20);

/**
 * SetResearchTagsRequest replaces a run's tag set wholesale.
 *
 * Deliberately NOT a field on UpdateResearchRequest: a repeated field cannot
 * express "unchanged" — absent and empty are identical on the wire — and the FE
 * sends UpdateResearchRequest on every rename, so folding tags in would clear
 * them on the next rename.
 *
 * The server sanitises (trimmed, lower-cased, deduped, <=32 tags of <=64 runes)
 * and replies with the full updated Research carrying the sanitised set, so the
 * client renders exactly what persisted.
 *
 * @generated from message lvdr.v2.research.SetResearchTagsRequest
 */
export type SetResearchTagsRequest = Message<"lvdr.v2.research.SetResearchTagsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];
};

/**
 * Describes the message lvdr.v2.research.SetResearchTagsRequest.
 * Use `create(SetResearchTagsRequestSchema)` to create a new message.
 */
export const SetResearchTagsRequestSchema: GenMessage<SetResearchTagsRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 21);

/**
 * Wave 2 HTTP→WS migration. Previously POST /api/v1/research/:id/priority.
 * Priority is an integer; higher values = scheduled ahead of lower ones.
 *
 * @generated from message lvdr.v2.research.SetResearchPriorityRequest
 */
export type SetResearchPriorityRequest = Message<"lvdr.v2.research.SetResearchPriorityRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 priority = 2;
   */
  priority: number;
};

/**
 * Describes the message lvdr.v2.research.SetResearchPriorityRequest.
 * Use `create(SetResearchPriorityRequestSchema)` to create a new message.
 */
export const SetResearchPriorityRequestSchema: GenMessage<SetResearchPriorityRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 22);

/**
 * @generated from message lvdr.v2.research.SetResearchPriorityResponse
 */
export type SetResearchPriorityResponse = Message<"lvdr.v2.research.SetResearchPriorityResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 priority = 2;
   */
  priority: number;
};

/**
 * Describes the message lvdr.v2.research.SetResearchPriorityResponse.
 * Use `create(SetResearchPriorityResponseSchema)` to create a new message.
 */
export const SetResearchPriorityResponseSchema: GenMessage<SetResearchPriorityResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 23);

/**
 * @generated from message lvdr.v2.research.MetadataRequest
 */
export type MetadataRequest = Message<"lvdr.v2.research.MetadataRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.MetadataRequest.
 * Use `create(MetadataRequestSchema)` to create a new message.
 */
export const MetadataRequestSchema: GenMessage<MetadataRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 24);

/**
 * @generated from message lvdr.v2.research.MetadataResponse
 */
export type MetadataResponse = Message<"lvdr.v2.research.MetadataResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string goal = 2;
   */
  goal: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string profile = 4;
   */
  profile: string;

  /**
   * @generated from field: double budget = 5;
   */
  budget: number;

  /**
   * @generated from field: double spent = 6;
   */
  spent: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.research.MetadataResponse.
 * Use `create(MetadataResponseSchema)` to create a new message.
 */
export const MetadataResponseSchema: GenMessage<MetadataResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 25);

/**
 * Responses
 *
 * @generated from message lvdr.v2.research.ResearchResponse
 */
export type ResearchResponse = Message<"lvdr.v2.research.ResearchResponse"> & {
  /**
   * @generated from field: lvdr.v2.research.Research research = 1;
   */
  research?: Research | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchResponse.
 * Use `create(ResearchResponseSchema)` to create a new message.
 */
export const ResearchResponseSchema: GenMessage<ResearchResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 26);

/**
 * @generated from message lvdr.v2.research.ResearchListResponse
 */
export type ResearchListResponse = Message<"lvdr.v2.research.ResearchListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.research.Research research = 1;
   */
  research: Research[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchListResponse.
 * Use `create(ResearchListResponseSchema)` to create a new message.
 */
export const ResearchListResponseSchema: GenMessage<ResearchListResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 27);

/**
 * @generated from message lvdr.v2.research.SummaryResponse
 */
export type SummaryResponse = Message<"lvdr.v2.research.SummaryResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string summary = 2;
   */
  summary: string;
};

/**
 * Describes the message lvdr.v2.research.SummaryResponse.
 * Use `create(SummaryResponseSchema)` to create a new message.
 */
export const SummaryResponseSchema: GenMessage<SummaryResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 28);

/**
 * Events
 *
 * @generated from message lvdr.v2.research.ResearchStatusUpdateEvent
 */
export type ResearchStatusUpdateEvent = Message<"lvdr.v2.research.ResearchStatusUpdateEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string previous_status = 3;
   */
  previousStatus: string;

  /**
   * timestamp is named 'timestamp' for historical reasons; newer event types
   * in this file use 'ts' (e.g. ResearchCreatedEvent.ts, ResearchUpdatedEvent.ts).
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 4;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: bool wrapping_up = 5;
   */
  wrappingUp: boolean;
};

/**
 * Describes the message lvdr.v2.research.ResearchStatusUpdateEvent.
 * Use `create(ResearchStatusUpdateEventSchema)` to create a new message.
 */
export const ResearchStatusUpdateEventSchema: GenMessage<ResearchStatusUpdateEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 29);

/**
 * ResearchCreatedEvent is broadcast to all of the user's WS connections when
 * a research is created. Carries the full Research so subscribers can patch
 * their local list without a re-fetch. Originator receives this too and
 * dedups via idempotent store upsert.
 *
 * @generated from message lvdr.v2.research.ResearchCreatedEvent
 */
export type ResearchCreatedEvent = Message<"lvdr.v2.research.ResearchCreatedEvent"> & {
  /**
   * @generated from field: lvdr.v2.research.Research research = 1;
   */
  research?: Research | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp ts = 2;
   */
  ts?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchCreatedEvent.
 * Use `create(ResearchCreatedEventSchema)` to create a new message.
 */
export const ResearchCreatedEventSchema: GenMessage<ResearchCreatedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 30);

/**
 * ResearchUpdatedEvent is broadcast on research rename/budget/title change.
 * Same delivery semantics as ResearchCreatedEvent.
 *
 * @generated from message lvdr.v2.research.ResearchUpdatedEvent
 */
export type ResearchUpdatedEvent = Message<"lvdr.v2.research.ResearchUpdatedEvent"> & {
  /**
   * @generated from field: lvdr.v2.research.Research research = 1;
   */
  research?: Research | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp ts = 2;
   */
  ts?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchUpdatedEvent.
 * Use `create(ResearchUpdatedEventSchema)` to create a new message.
 */
export const ResearchUpdatedEventSchema: GenMessage<ResearchUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 31);

/**
 * Domain model
 *
 * @generated from message lvdr.v2.research.Research
 */
export type Research = Message<"lvdr.v2.research.Research"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string goal = 2;
   */
  goal: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: double budget = 4;
   */
  budget: number;

  /**
   * @generated from field: double spent = 5;
   */
  spent: number;

  /**
   * @generated from field: string profile = 6;
   */
  profile: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string title = 9;
   */
  title: string;

  /**
   * @generated from field: string summary = 10;
   */
  summary: string;

  /**
   * @generated from field: int32 total_nodes = 11;
   */
  totalNodes: number;

  /**
   * @generated from field: int32 completed_nodes = 12;
   */
  completedNodes: number;

  /**
   * @generated from field: int32 failed_nodes = 13;
   */
  failedNodes: number;

  /**
   * @generated from field: int32 max_depth = 14;
   */
  maxDepth: number;

  /**
   * @generated from field: bool is_reference = 15;
   */
  isReference: boolean;

  /**
   * Reading-metrics enrichment (sourced from ResearchStats during list/get).
   * Populated lazily on first GetResearchResult; older research are blank
   * until viewed once.
   *
   * @generated from field: int32 word_count = 16;
   */
  wordCount: number;

  /**
   * @generated from field: int32 reading_time_minutes = 17;
   */
  readingTimeMinutes: number;

  /**
   * Diagram enhancement preferences (Phase 8). Optional; legacy research
   * round-trip with empty / false. `diagram_style` is the preset ID
   * (matches `internal/diagrams/presets`). `diagram_style_override` is
   * free-form prose, capped at 500 chars on the WS boundary.
   * `diagram_enhancement_on` drives the flow-1 auto-on-completion trigger.
   *
   * @generated from field: string diagram_style = 18;
   */
  diagramStyle: string;

  /**
   * @generated from field: string diagram_style_override = 19;
   */
  diagramStyleOverride: string;

  /**
   * @generated from field: bool diagram_enhancement_on = 20;
   */
  diagramEnhancementOn: boolean;

  /**
   * Ordered, user-facing phase strip for strategy-driven research. Empty
   * for v2/non-strategy research (the FE hides the strip in that case).
   * Sourced from the strategy YAML's display_phases at StartStrategyResearch
   * time and persisted on ResearchMetadata.
   *
   * @generated from field: repeated string display_phases = 21;
   */
  displayPhases: string[];

  /**
   * Credits spent on this research, sourced from credit_transactions tagged
   * with reference_id = research_id. Populated server-side on the
   * single-research AND list read paths (one batched ledger query per page);
   * see credits_known / credits_state for whether it is meaningful. Surfaced as the
   * "Credits used N" row in the research details panel (replacing the
   * legacy USD-framed "Budget $X" display).
   *
   * @generated from field: int64 credits_spent = 22;
   */
  creditsSpent: bigint;

  /**
   * Research-in-Workspace (E1): the Workspace this run files
   * into on successful completion, and where the filing stands.
   * destination_workspace_id is empty for personal runs. filing_status is one
   * of "" (personal), "pending" (awaiting completion or a mounted session
   * holding the workspace key), "filed" (transferred into the workspace), or
   * "failed" (transfer failed — run stays personal, manual transfer remains
   * available). Legacy research round-trip with both empty.
   *
   * @generated from field: string destination_workspace_id = 23;
   */
  destinationWorkspaceId: string;

  /**
   * @generated from field: string filing_status = 24;
   */
  filingStatus: string;

  /**
   * True when credits_spent reflects a completed ledger lookup (on the single
   * OR list read path). False when enrichment was skipped or failed, or the
   * user is not billed — in which case credits_spent is a meaningless 0;
   * credits_state (field 29) says why, and the FE shows "Not billed" for
   * CREDITS_STATE_NOT_BILLED / CREDITS_STATE_BILLING_DISABLED and "—"
   * otherwise. This lets the UI distinguish "free" (known, 0 credits) from "unknown". Always
   * false on create/update broadcasts (metadataToProto does not enrich); the FE
   * store preserves a previously-known value across those events.
   *
   * @generated from field: bool credits_known = 25;
   */
  creditsKnown: boolean;

  /**
   * The per-run credit CEILING resolved at start from
   * research.budget.hard_ceiling_credits (0 = uncapped). Never serialized
   * before this, which is why the UI could show spend but no cap, no
   * percentage and no remaining headroom.
   *
   * NOT the same thing as `budget` (field 4) above, which is the legacy
   * Config.BudgetLimit — an unrelated number that the budget-extension dialog
   * edits. Do not conflate them.
   *
   * credits_spent may legitimately EXCEED this: hitting the ceiling triggers
   * wind-down, and the synthesis that writes the report spends past it. That
   * includes the output form's section writers, which the wind-down exempts
   * from its no-op only since RSCH-35 (NodeGrowsGraph); before it, a wound-down
   * run wrote no report at all (prod 367bb4e6). See common.WindDownReason.
   *
   * @generated from field: int64 credit_ceiling = 26;
   */
  creditCeiling: bigint;

  /**
   * User-applied labels on the run. Lower-cased, deduped and bounded
   * server-side (32 tags x 64 runes). Empty for runs never tagged; legacy
   * research round-trip with it absent. Read by the `research` workflow
   * trigger's tags_any filter.
   *
   * @generated from field: repeated string tags = 27;
   */
  tags: string[];

  /**
   * True when this run's metadata was SYNTHESISED from its node data rather
   * than read from the run's own store — i.e. the record was genuinely lost and
   * the read path fabricated a replacement (RSCH-15).
   *
   * Everything but the query in such a record is invented, most consequentially
   * the status: the stub hard-codes "completed", so a failed or cancelled run
   * comes back presented as a successful one, with its title, summary, tags and
   * config gone. Without this flag that record is indistinguishable from a real
   * one for every reader, which is why it is on the wire and not only on disk.
   *
   * Absent (false) for every run written normally, and for every legacy row.
   *
   * @generated from field: bool recovered = 28;
   */
  recovered: boolean;

  /**
   * Why credits_spent is or is not meaningful — see enum CreditsState above.
   * Set only by the enriched get/list read paths; UNSPECIFIED everywhere else.
   *
   * @generated from field: lvdr.v2.research.CreditsState credits_state = 29;
   */
  creditsState: CreditsState;
};

/**
 * Describes the message lvdr.v2.research.Research.
 * Use `create(ResearchSchema)` to create a new message.
 */
export const ResearchSchema: GenMessage<Research> = /*@__PURE__*/
  messageDesc(file_research_research, 32);

/**
 * ResearchConfigRequest is sent by the client to initiate intent analysis.
 * On first call, chat_message and previous_strategy_id are empty.
 * On refinement calls, the client sends the user's chat message.
 *
 * @generated from message lvdr.v2.research.ResearchConfigRequest
 */
export type ResearchConfigRequest = Message<"lvdr.v2.research.ResearchConfigRequest"> & {
  /**
   * The user's research prompt
   *
   * @generated from field: string goal = 1;
   */
  goal: string;

  /**
   * Free text refinement (empty on first call)
   *
   * @generated from field: string chat_message = 2;
   */
  chatMessage: string;

  /**
   * Strategy from previous analysis (empty on first call)
   *
   * @generated from field: string previous_strategy_id = 3;
   */
  previousStrategyId: string;
};

/**
 * Describes the message lvdr.v2.research.ResearchConfigRequest.
 * Use `create(ResearchConfigRequestSchema)` to create a new message.
 */
export const ResearchConfigRequestSchema: GenMessage<ResearchConfigRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 33);

/**
 * ConfigQuestion represents a single HITL question for the user.
 *
 * @generated from message lvdr.v2.research.ConfigQuestion
 */
export type ConfigQuestion = Message<"lvdr.v2.research.ConfigQuestion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: repeated lvdr.v2.research.ConfigChoice choices = 3;
   */
  choices: ConfigChoice[];

  /**
   * @generated from field: string default_value = 4;
   */
  defaultValue: string;

  /**
   * @generated from field: bool is_llm_generated = 5;
   */
  isLlmGenerated: boolean;
};

/**
 * Describes the message lvdr.v2.research.ConfigQuestion.
 * Use `create(ConfigQuestionSchema)` to create a new message.
 */
export const ConfigQuestionSchema: GenMessage<ConfigQuestion> = /*@__PURE__*/
  messageDesc(file_research_research, 34);

/**
 * ConfigChoice represents a single option in a ConfigQuestion.
 *
 * @generated from message lvdr.v2.research.ConfigChoice
 */
export type ConfigChoice = Message<"lvdr.v2.research.ConfigChoice"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.research.ConfigChoice.
 * Use `create(ConfigChoiceSchema)` to create a new message.
 */
export const ConfigChoiceSchema: GenMessage<ConfigChoice> = /*@__PURE__*/
  messageDesc(file_research_research, 35);

/**
 * VoiceOption describes a named voice fingerprint available for selection.
 *
 * @generated from message lvdr.v2.research.VoiceOption
 */
export type VoiceOption = Message<"lvdr.v2.research.VoiceOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: map<string, string> traits = 4;
   */
  traits: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.research.VoiceOption.
 * Use `create(VoiceOptionSchema)` to create a new message.
 */
export const VoiceOptionSchema: GenMessage<VoiceOption> = /*@__PURE__*/
  messageDesc(file_research_research, 36);

/**
 * PromptAnalysis is Stage-1 output of the v2 classifier. Mirrors the BAML
 * PromptAnalysis class.
 *
 * @generated from message lvdr.v2.research.PromptAnalysis
 */
export type PromptAnalysis = Message<"lvdr.v2.research.PromptAnalysis"> & {
  /**
   * @generated from field: int32 entity_count = 1;
   */
  entityCount: number;

  /**
   * "narrow" | "medium" | "broad"
   *
   * @generated from field: string scope_breadth = 2;
   */
  scopeBreadth: string;

  /**
   * "explore" | "compare" | "verify" | "survey"
   *
   * @generated from field: string intent_kind = 3;
   */
  intentKind: string;

  /**
   * @generated from field: bool iteration_hint = 4;
   */
  iterationHint: boolean;

  /**
   * @generated from field: repeated string cited_urls = 5;
   */
  citedUrls: string[];
};

/**
 * Describes the message lvdr.v2.research.PromptAnalysis.
 * Use `create(PromptAnalysisSchema)` to create a new message.
 */
export const PromptAnalysisSchema: GenMessage<PromptAnalysis> = /*@__PURE__*/
  messageDesc(file_research_research, 37);

/**
 * StrategyCandidate is one ranked option from RankStrategies. The frontend
 * receives the top 3 of these as pills.
 *
 * @generated from message lvdr.v2.research.StrategyCandidate
 */
export type StrategyCandidate = Message<"lvdr.v2.research.StrategyCandidate"> & {
  /**
   * @generated from field: string strategy_id = 1;
   */
  strategyId: string;

  /**
   * @generated from field: float confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: string reasoning = 3;
   */
  reasoning: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: repeated lvdr.v2.research.ConfigQuestion questions = 6;
   */
  questions: ConfigQuestion[];
};

/**
 * Describes the message lvdr.v2.research.StrategyCandidate.
 * Use `create(StrategyCandidateSchema)` to create a new message.
 */
export const StrategyCandidateSchema: GenMessage<StrategyCandidate> = /*@__PURE__*/
  messageDesc(file_research_research, 38);

/**
 * ResearchConfigResponse is sent by the server with analysis results.
 *
 * @generated from message lvdr.v2.research.ResearchConfigResponse
 */
export type ResearchConfigResponse = Message<"lvdr.v2.research.ResearchConfigResponse"> & {
  /**
   * @generated from field: string strategy_id = 1;
   */
  strategyId: string;

  /**
   * @generated from field: double confidence = 2;
   */
  confidence: number;

  /**
   * @generated from field: repeated string detected_entities = 3;
   */
  detectedEntities: string[];

  /**
   * @generated from field: repeated string detected_dimensions = 4;
   */
  detectedDimensions: string[];

  /**
   * @generated from field: string suggested_output_form = 5;
   */
  suggestedOutputForm: string;

  /**
   * @generated from field: repeated string grounding_queries = 6;
   */
  groundingQueries: string[];

  /**
   * @generated from field: repeated lvdr.v2.research.ConfigQuestion questions = 7;
   */
  questions: ConfigQuestion[];

  /**
   * @generated from field: string reasoning = 8;
   */
  reasoning: string;

  /**
   * @generated from field: repeated lvdr.v2.research.VoiceOption available_voices = 9;
   */
  availableVoices: VoiceOption[];

  /**
   * V2 classifier additions (additive — old clients ignore unknown fields).
   *
   * @generated from field: lvdr.v2.research.PromptAnalysis prompt_analysis = 10;
   */
  promptAnalysis?: PromptAnalysis | undefined;

  /**
   * top 3 only, sorted by confidence desc
   *
   * @generated from field: repeated lvdr.v2.research.StrategyCandidate candidates = 11;
   */
  candidates: StrategyCandidate[];

  /**
   * true when top-1 confidence < 0.70
   *
   * @generated from field: bool requires_user_selection = 12;
   */
  requiresUserSelection: boolean;
};

/**
 * Describes the message lvdr.v2.research.ResearchConfigResponse.
 * Use `create(ResearchConfigResponseSchema)` to create a new message.
 */
export const ResearchConfigResponseSchema: GenMessage<ResearchConfigResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 39);

/**
 * ConfigGoRequest is sent by the client when the user presses GO.
 * Contains the user's answers to the configuration questions.
 *
 * @generated from message lvdr.v2.research.ConfigGoRequest
 */
export type ConfigGoRequest = Message<"lvdr.v2.research.ConfigGoRequest"> & {
  /**
   * @generated from field: string goal = 1;
   */
  goal: string;

  /**
   * @generated from field: string strategy_id = 2;
   */
  strategyId: string;

  /**
   * @generated from field: map<string, string> answers = 3;
   */
  answers: { [key: string]: string };

  /**
   * @generated from field: string output_form = 4;
   */
  outputForm: string;

  /**
   * Diagram enhancement seed (Phase 8) — same shape as
   * CreateResearchRequest. When all three are zero-valued the server
   * falls back to the user-settings global toggle.
   *
   * @generated from field: string diagram_style = 5;
   */
  diagramStyle: string;

  /**
   * @generated from field: string diagram_style_override = 6;
   */
  diagramStyleOverride: string;

  /**
   * @generated from field: bool diagram_enhancement_on = 7;
   */
  diagramEnhancementOn: boolean;

  /**
   * Research-in-Workspace (E1) — same semantics as
   * CreateResearchRequest.workspace_id: file the run into this ACTIVE,
   * read_write-mounted Workspace on successful completion.
   *
   * @generated from field: string workspace_id = 8;
   */
  workspaceId: string;

  /**
   * R8 i18n Phase 2: explicit output language for generated prose
   * (BCP-47). Empty = not set — the server resolves via user locale →
   * enricher language detection → English.
   *
   * @generated from field: string output_language = 9;
   */
  outputLanguage: string;
};

/**
 * Describes the message lvdr.v2.research.ConfigGoRequest.
 * Use `create(ConfigGoRequestSchema)` to create a new message.
 */
export const ConfigGoRequestSchema: GenMessage<ConfigGoRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 40);

/**
 * ConfigGoResponse acknowledges the GO and includes the created research ID.
 *
 * @generated from message lvdr.v2.research.ConfigGoResponse
 */
export type ConfigGoResponse = Message<"lvdr.v2.research.ConfigGoResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string strategy_id = 2;
   */
  strategyId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.research.ConfigGoResponse.
 * Use `create(ConfigGoResponseSchema)` to create a new message.
 */
export const ConfigGoResponseSchema: GenMessage<ConfigGoResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 41);

/**
 * GenerateReportRequest triggers generation of a new report in the research's
 * report library. Replaces the legacy GenerateOutputFormRequest (which was a
 * default-stub handler, no functional regression). Field 343 on the envelope
 * oneof carries this message; see envelope.proto.
 *
 * Modes:
 *   - WRITER_ONLY: rerun the report tail (section_prepare → writer → concat)
 *     against the existing research chunkstore with a new focus / output form.
 *   - TOP_UP:      add a bounded research pass (lead_dimension strategy,
 *     budget-capped) before regenerating the report.
 *   - FULL_RESEARCH: flip research Completed → Running, run a full strategy
 *     against the research's existing store, then regenerate the report.
 *   - DERIVATIVE:  single BAML call (MakeDerivative) over a parent report's
 *     prose; produces exec_summary / linkedin / news style outputs.
 *
 * @generated from message lvdr.v2.research.GenerateReportRequest
 */
export type GenerateReportRequest = Message<"lvdr.v2.research.GenerateReportRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: lvdr.v2.research.GenerateReportRequest.Mode mode = 2;
   */
  mode: GenerateReportRequest_Mode;

  /**
   * @generated from field: string focus = 3;
   */
  focus: string;

  /**
   * "full" by default
   *
   * @generated from field: string output_form = 4;
   */
  outputForm: string;

  /**
   * required for MODE_DERIVATIVE
   *
   * @generated from field: string parent_report_id = 5;
   */
  parentReportId: string;

  /**
   * auto-derived if empty
   *
   * @generated from field: string label = 6;
   */
  label: string;

  /**
   * optional per-report style instruction; "" = no injection
   *
   * @generated from field: string writing_style = 7;
   */
  writingStyle: string;

  /**
   * R8 i18n Phase 2: explicit output language for this run's prose (BCP-47).
   * "" = not set — the server resolves via the research's persisted
   * output_language → user locale → English.
   *
   * @generated from field: string output_language = 8;
   */
  outputLanguage: string;
};

/**
 * Describes the message lvdr.v2.research.GenerateReportRequest.
 * Use `create(GenerateReportRequestSchema)` to create a new message.
 */
export const GenerateReportRequestSchema: GenMessage<GenerateReportRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 42);

/**
 * @generated from enum lvdr.v2.research.GenerateReportRequest.Mode
 */
export enum GenerateReportRequest_Mode {
  /**
   * @generated from enum value: MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MODE_WRITER_ONLY = 1;
   */
  WRITER_ONLY = 1,

  /**
   * @generated from enum value: MODE_TOP_UP = 2;
   */
  TOP_UP = 2,

  /**
   * @generated from enum value: MODE_FULL_RESEARCH = 3;
   */
  FULL_RESEARCH = 3,

  /**
   * @generated from enum value: MODE_DERIVATIVE = 4;
   */
  DERIVATIVE = 4,
}

/**
 * Describes the enum lvdr.v2.research.GenerateReportRequest.Mode.
 */
export const GenerateReportRequest_ModeSchema: GenEnum<GenerateReportRequest_Mode> = /*@__PURE__*/
  enumDesc(file_research_research, 42, 0);

/**
 * GenerateReportResponse acknowledges a GenerateReportRequest. status:
 *   - "started":  estimate below the user's auto-approve threshold; the
 *                 report run is dispatching asynchronously.
 *   - "queued":   estimate at-or-above threshold; a ReportRunCostApproval
 *                 HITL has been emitted, dispatch waits on approval.
 *   - "rejected": validation failed (see `reason`).
 *
 * @generated from message lvdr.v2.research.GenerateReportResponse
 */
export type GenerateReportResponse = Message<"lvdr.v2.research.GenerateReportResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string report_run_node_id = 2;
   */
  reportRunNodeId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.research.GenerateReportResponse.
 * Use `create(GenerateReportResponseSchema)` to create a new message.
 */
export const GenerateReportResponseSchema: GenMessage<GenerateReportResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 43);

/**
 * EstimateReportRunRequest is a lightweight cost preview for inline FE
 * display. The frontend debounces this on mode/output-form changes so the
 * estimate stays current as the user fiddles with the modal.
 *
 * @generated from message lvdr.v2.research.EstimateReportRunRequest
 */
export type EstimateReportRunRequest = Message<"lvdr.v2.research.EstimateReportRunRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: lvdr.v2.research.GenerateReportRequest.Mode mode = 2;
   */
  mode: GenerateReportRequest_Mode;

  /**
   * @generated from field: string output_form = 3;
   */
  outputForm: string;

  /**
   * @generated from field: string parent_report_id = 4;
   */
  parentReportId: string;
};

/**
 * Describes the message lvdr.v2.research.EstimateReportRunRequest.
 * Use `create(EstimateReportRunRequestSchema)` to create a new message.
 */
export const EstimateReportRunRequestSchema: GenMessage<EstimateReportRunRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 44);

/**
 * EstimateReportRunResponse carries the cost estimate plus its confidence
 * band. `auto_approves` is the server's threshold check against the user's
 * `report_run_auto_approve_credits` setting — surfaced so the FE doesn't
 * have to recompute the gate.
 *
 * @generated from message lvdr.v2.research.EstimateReportRunResponse
 */
export type EstimateReportRunResponse = Message<"lvdr.v2.research.EstimateReportRunResponse"> & {
  /**
   * @generated from field: int64 estimated_credits = 1;
   */
  estimatedCredits: bigint;

  /**
   * "exact" | "bounded" | "heuristic"
   *
   * @generated from field: string confidence = 2;
   */
  confidence: string;

  /**
   * @generated from field: string breakdown = 3;
   */
  breakdown: string;

  /**
   * @generated from field: bool auto_approves = 4;
   */
  autoApproves: boolean;
};

/**
 * Describes the message lvdr.v2.research.EstimateReportRunResponse.
 * Use `create(EstimateReportRunResponseSchema)` to create a new message.
 */
export const EstimateReportRunResponseSchema: GenMessage<EstimateReportRunResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 45);

/**
 * ReportRunProgressEvent is an EPHEMERAL (never persisted) progress signal for a
 * single in-flight report version, keyed to its report-run anchor node. Emitted
 * only for the writer_only and derivative dispatch paths, which otherwise send
 * nothing between the initial `running` and the terminal node update. Pass modes
 * (top_up/full_research) reuse the whole-research execution progress instead.
 *
 * `stage` is a fixed per-mode enum-as-string:
 *   writer_only: "gathering_context" -> "synthesizing" -> "finalizing"
 *   derivative:  "reshaping" -> "finalizing"
 * `completed`/`total` are determinate only when total>0 (e.g. synthesis batch
 * k/K when the reduce splits); total=0 means render an indeterminate bar.
 *
 * @generated from message lvdr.v2.research.ReportRunProgressEvent
 */
export type ReportRunProgressEvent = Message<"lvdr.v2.research.ReportRunProgressEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * the report-run anchor version node id
   *
   * @generated from field: string report_node_id = 2;
   */
  reportNodeId: string;

  /**
   * @generated from field: string stage = 3;
   */
  stage: string;

  /**
   * @generated from field: int32 completed = 4;
   */
  completed: number;

  /**
   * @generated from field: int32 total = 5;
   */
  total: number;

  /**
   * optional free-text detail (e.g. current batch)
   *
   * @generated from field: string label = 6;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.research.ReportRunProgressEvent.
 * Use `create(ReportRunProgressEventSchema)` to create a new message.
 */
export const ReportRunProgressEventSchema: GenMessage<ReportRunProgressEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 46);

/**
 * CancelReportRunRequest cancels an in-flight writer_only/derivative report run
 * by its anchor node id. Pass-mode (top_up/full_research) versions are cancelled
 * via the existing CancelExecutionRequest (a pass IS the whole research), so this
 * message is only sent for writer_only/derivative rows.
 *
 * @generated from message lvdr.v2.research.CancelReportRunRequest
 */
export type CancelReportRunRequest = Message<"lvdr.v2.research.CancelReportRunRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string report_node_id = 2;
   */
  reportNodeId: string;
};

/**
 * Describes the message lvdr.v2.research.CancelReportRunRequest.
 * Use `create(CancelReportRunRequestSchema)` to create a new message.
 */
export const CancelReportRunRequestSchema: GenMessage<CancelReportRunRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 47);

/**
 * CancelReportRunResponse acks a cancel. status: "cancelling" (registry hit),
 * "noop" (unknown/already-finished anchor), "delegate_execution" (a pass anchor
 * reached this handler — the FE should have used CancelExecutionRequest).
 *
 * @generated from message lvdr.v2.research.CancelReportRunResponse
 */
export type CancelReportRunResponse = Message<"lvdr.v2.research.CancelReportRunResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string report_node_id = 2;
   */
  reportNodeId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.research.CancelReportRunResponse.
 * Use `create(CancelReportRunResponseSchema)` to create a new message.
 */
export const CancelReportRunResponseSchema: GenMessage<CancelReportRunResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 48);

/**
 * ListResearchOutputFormsRequest asks the server for the catalog of output
 * forms applicable to a research — the union of:
 *   • the strategy's `output` intent-question choices (primary forms; a new
 *     writer pass produces them), and
 *   • the strategy's `available_post_forms` list (reshape forms; produced by
 *     deriving from an existing report).
 * Surfaced in the Generate-report dialog so the user picks from the same
 * catalog they saw at research setup, not the dialog-hardcoded subset.
 *
 * @generated from message lvdr.v2.research.ListResearchOutputFormsRequest
 */
export type ListResearchOutputFormsRequest = Message<"lvdr.v2.research.ListResearchOutputFormsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.research.ListResearchOutputFormsRequest.
 * Use `create(ListResearchOutputFormsRequestSchema)` to create a new message.
 */
export const ListResearchOutputFormsRequestSchema: GenMessage<ListResearchOutputFormsRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 49);

/**
 * OutputFormChoice is one entry in the research's output-form catalog. `kind`
 * distinguishes how the form is produced (`primary` = full writer pass;
 * `post_processing` = derivative-style reshape of an existing report).
 *
 * @generated from message lvdr.v2.research.OutputFormChoice
 */
export type OutputFormChoice = Message<"lvdr.v2.research.OutputFormChoice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * "primary" | "post_processing"
   *
   * @generated from field: string kind = 4;
   */
  kind: string;
};

/**
 * Describes the message lvdr.v2.research.OutputFormChoice.
 * Use `create(OutputFormChoiceSchema)` to create a new message.
 */
export const OutputFormChoiceSchema: GenMessage<OutputFormChoice> = /*@__PURE__*/
  messageDesc(file_research_research, 50);

/**
 * ListResearchOutputFormsResponse carries the research's catalog. `default_id`
 * is the strategy's suggested output form (so the dialog can pre-select it).
 * Returned forms are de-duplicated across primary + post-processing — a YAML
 * form flagged both ways surfaces only once with its primary kind.
 *
 * @generated from message lvdr.v2.research.ListResearchOutputFormsResponse
 */
export type ListResearchOutputFormsResponse = Message<"lvdr.v2.research.ListResearchOutputFormsResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.research.OutputFormChoice forms = 2;
   */
  forms: OutputFormChoice[];

  /**
   * @generated from field: string default_id = 3;
   */
  defaultId: string;
};

/**
 * Describes the message lvdr.v2.research.ListResearchOutputFormsResponse.
 * Use `create(ListResearchOutputFormsResponseSchema)` to create a new message.
 */
export const ListResearchOutputFormsResponseSchema: GenMessage<ListResearchOutputFormsResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 51);

/**
 * GetResearchDefaultsCatalogRequest fetches the static catalog the settings
 * page needs to render the research-defaults editor WITHOUT analyzing a prompt:
 * every selectable strategy with its YAML intent-questions and the voice
 * catalog. Read-only.
 *
 * @generated from message lvdr.v2.research.GetResearchDefaultsCatalogRequest
 */
export type GetResearchDefaultsCatalogRequest = Message<"lvdr.v2.research.GetResearchDefaultsCatalogRequest"> & {
};

/**
 * Describes the message lvdr.v2.research.GetResearchDefaultsCatalogRequest.
 * Use `create(GetResearchDefaultsCatalogRequestSchema)` to create a new message.
 */
export const GetResearchDefaultsCatalogRequestSchema: GenMessage<GetResearchDefaultsCatalogRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 52);

/**
 * StrategyConfig is one strategy's static configuration surface: its identity
 * plus the YAML `intent_questions` (verbatim — already display-substituted at
 * load). The FE renders each question's choices as default-selectable chips.
 *
 * @generated from message lvdr.v2.research.StrategyConfig
 */
export type StrategyConfig = Message<"lvdr.v2.research.StrategyConfig"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated lvdr.v2.research.ConfigQuestion questions = 4;
   */
  questions: ConfigQuestion[];
};

/**
 * Describes the message lvdr.v2.research.StrategyConfig.
 * Use `create(StrategyConfigSchema)` to create a new message.
 */
export const StrategyConfigSchema: GenMessage<StrategyConfig> = /*@__PURE__*/
  messageDesc(file_research_research, 53);

/**
 * GetResearchDefaultsCatalogResponse carries everything the research-defaults
 * editor renders. `voices` reuses the existing VoiceOption message.
 *
 * @generated from message lvdr.v2.research.GetResearchDefaultsCatalogResponse
 */
export type GetResearchDefaultsCatalogResponse = Message<"lvdr.v2.research.GetResearchDefaultsCatalogResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.research.StrategyConfig strategies = 1;
   */
  strategies: StrategyConfig[];

  /**
   * @generated from field: repeated lvdr.v2.research.VoiceOption voices = 2;
   */
  voices: VoiceOption[];
};

/**
 * Describes the message lvdr.v2.research.GetResearchDefaultsCatalogResponse.
 * Use `create(GetResearchDefaultsCatalogResponseSchema)` to create a new message.
 */
export const GetResearchDefaultsCatalogResponseSchema: GenMessage<GetResearchDefaultsCatalogResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 54);

/**
 * SaveResearchAsDocumentRequest copies a completed research's assembled
 * report into the user's document library so it can be reused as
 * reference material in future chats and research.
 *
 * @generated from message lvdr.v2.research.SaveResearchAsDocumentRequest
 */
export type SaveResearchAsDocumentRequest = Message<"lvdr.v2.research.SaveResearchAsDocumentRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * Optional placement overrides. Empty values preserve prior behaviour:
   * server-derived title fallback, no tags, no collection. Old clients that
   * send only research_id are unaffected (proto3 zero-values).
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: string collection_id = 4;
   */
  collectionId: string;
};

/**
 * Describes the message lvdr.v2.research.SaveResearchAsDocumentRequest.
 * Use `create(SaveResearchAsDocumentRequestSchema)` to create a new message.
 */
export const SaveResearchAsDocumentRequestSchema: GenMessage<SaveResearchAsDocumentRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 55);

/**
 * SaveResearchAsDocumentResponse returns the new document's id and the
 * title under which it was saved (research title, falling back to the
 * goal). Indexing happens asynchronously after the upload — clients
 * should treat status="pending" as "saved, indexing in progress".
 *
 * @generated from message lvdr.v2.research.SaveResearchAsDocumentResponse
 */
export type SaveResearchAsDocumentResponse = Message<"lvdr.v2.research.SaveResearchAsDocumentResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.research.SaveResearchAsDocumentResponse.
 * Use `create(SaveResearchAsDocumentResponseSchema)` to create a new message.
 */
export const SaveResearchAsDocumentResponseSchema: GenMessage<SaveResearchAsDocumentResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 56);

/**
 * ----- Report Diagrams (Phase 7) -----
 *
 * `ResearchDiagram` is the per-research registry row mirrored from
 * `internal/diagrams.ResearchDiagram`. It is the source of truth for the
 * Diagrams tab; the marker block in the report markdown is the rendering
 * view. Field ordering follows the design doc's Section 4 layout. New
 * fields must be appended (not inserted) to preserve wire compatibility.
 *
 * @generated from message lvdr.v2.research.ResearchDiagram
 */
export type ResearchDiagram = Message<"lvdr.v2.research.ResearchDiagram"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;

  /**
   * "kroki" | "gemini-image" | "paperbanana"
   *
   * @generated from field: string generator = 4;
   */
  generator: string;

  /**
   * "mermaid" | "d2" | "excalidraw" | "bpmn" | "image"
   *
   * @generated from field: string kind = 5;
   */
  kind: string;

  /**
   * raw kroki source OR markdown image link
   *
   * @generated from field: string body = 6;
   */
  body: string;

  /**
   * @generated from field: string caption = 7;
   */
  caption: string;

  /**
   * @generated from field: string intent = 8;
   */
  intent: string;

  /**
   * @generated from field: string source_passage = 9;
   */
  sourcePassage: string;

  /**
   * @generated from field: string style_preset = 10;
   */
  stylePreset: string;

  /**
   * @generated from field: string style_override = 11;
   */
  styleOverride: string;

  /**
   * "pinned" | "draft" | "orphaned" | "failed"
   *
   * @generated from field: string status = 12;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp pinned_at = 13;
   */
  pinnedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp unpinned_at = 14;
   */
  unpinnedAt?: Timestamp | undefined;

  /**
   * @generated from field: string artifact_id = 15;
   */
  artifactId: string;

  /**
   * @generated from field: string thumbnail_url = 16;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string failure_reason = 17;
   */
  failureReason: string;

  /**
   * Origin (flat-stamped — the wire shape skips the nested Origin message).
   *
   * "enhancer-auto" | "enhancer-skill" | "chat-draft" | "chat-pin"
   *
   * @generated from field: string origin_source = 18;
   */
  originSource: string;

  /**
   * @generated from field: string origin_job_id = 19;
   */
  originJobId: string;

  /**
   * @generated from field: string origin_chat_msg_id = 20;
   */
  originChatMsgId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string created_by = 23;
   */
  createdBy: string;
};

/**
 * Describes the message lvdr.v2.research.ResearchDiagram.
 * Use `create(ResearchDiagramSchema)` to create a new message.
 */
export const ResearchDiagramSchema: GenMessage<ResearchDiagram> = /*@__PURE__*/
  messageDesc(file_research_research, 57);

/**
 * `DiagramEnhancementJob` mirrors `internal/diagrams.EnhancerJob` for the wire.
 * Surfaced via `DiagramEnhancementJobUpdateEvent` so the FE can show the
 * inline "diagrams updating..." indicator + tab job state.
 *
 * @generated from message lvdr.v2.research.DiagramEnhancementJob
 */
export type DiagramEnhancementJob = Message<"lvdr.v2.research.DiagramEnhancementJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string owner_id = 3;
   */
  ownerId: string;

  /**
   * @generated from field: string generator = 4;
   */
  generator: string;

  /**
   * @generated from field: int32 source_revision = 5;
   */
  sourceRevision: number;

  /**
   * "pending" | "running" | "completed" | "partial" | "failed"
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int32 opportunities_proposed = 7;
   */
  opportunitiesProposed: number;

  /**
   * @generated from field: int32 opportunities_embedded = 8;
   */
  opportunitiesEmbedded: number;

  /**
   * @generated from field: string style_preset = 9;
   */
  stylePreset: string;

  /**
   * @generated from field: string style_override = 10;
   */
  styleOverride: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 11;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 12;
   */
  completedAt?: Timestamp | undefined;

  /**
   * failure_summary is serialised JSON of the FailureDetails struct
   * (Class, Message). Carried as JSON to keep the wire schema simple.
   *
   * @generated from field: string failure_summary_json = 13;
   */
  failureSummaryJson: string;

  /**
   * "auto" | "skill" | "chat-pin"
   *
   * @generated from field: string source = 14;
   */
  source: string;
};

/**
 * Describes the message lvdr.v2.research.DiagramEnhancementJob.
 * Use `create(DiagramEnhancementJobSchema)` to create a new message.
 */
export const DiagramEnhancementJobSchema: GenMessage<DiagramEnhancementJob> = /*@__PURE__*/
  messageDesc(file_research_research, 58);

/**
 * RunDiagramEnhancementRequest kicks off a flow-3 (manual skill) job. Empty
 * `generator` defaults to "kroki" server-side. `style_override` falls back to
 * the research metadata's stored override when empty. `max_opportunities` of
 * zero falls back to the server default cap. `polish_diagrams`, when true,
 * re-runs every Kroki-text result through the gemini-image generator to
 * produce a polished raster — the source row is preserved as a draft for
 * editability; the polished row is what gets pinned into the report markdown.
 *
 * @generated from message lvdr.v2.research.RunDiagramEnhancementRequest
 */
export type RunDiagramEnhancementRequest = Message<"lvdr.v2.research.RunDiagramEnhancementRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string generator = 2;
   */
  generator: string;

  /**
   * @generated from field: string style_override = 3;
   */
  styleOverride: string;

  /**
   * @generated from field: int32 max_opportunities = 4;
   */
  maxOpportunities: number;

  /**
   * @generated from field: bool polish_diagrams = 5;
   */
  polishDiagrams: boolean;
};

/**
 * Describes the message lvdr.v2.research.RunDiagramEnhancementRequest.
 * Use `create(RunDiagramEnhancementRequestSchema)` to create a new message.
 */
export const RunDiagramEnhancementRequestSchema: GenMessage<RunDiagramEnhancementRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 59);

/**
 * @generated from message lvdr.v2.research.RunDiagramEnhancementResponse
 */
export type RunDiagramEnhancementResponse = Message<"lvdr.v2.research.RunDiagramEnhancementResponse"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.research.RunDiagramEnhancementResponse.
 * Use `create(RunDiagramEnhancementResponseSchema)` to create a new message.
 */
export const RunDiagramEnhancementResponseSchema: GenMessage<RunDiagramEnhancementResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 60);

/**
 * @generated from message lvdr.v2.research.GetResearchDiagramsRequest
 */
export type GetResearchDiagramsRequest = Message<"lvdr.v2.research.GetResearchDiagramsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * empty = all
   *
   * @generated from field: repeated string status_filter = 2;
   */
  statusFilter: string[];

  /**
   * empty = all
   *
   * @generated from field: repeated string generator_filter = 3;
   */
  generatorFilter: string[];
};

/**
 * Describes the message lvdr.v2.research.GetResearchDiagramsRequest.
 * Use `create(GetResearchDiagramsRequestSchema)` to create a new message.
 */
export const GetResearchDiagramsRequestSchema: GenMessage<GetResearchDiagramsRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 61);

/**
 * @generated from message lvdr.v2.research.ResearchDiagramsResponse
 */
export type ResearchDiagramsResponse = Message<"lvdr.v2.research.ResearchDiagramsResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.research.ResearchDiagram diagrams = 2;
   */
  diagrams: ResearchDiagram[];
};

/**
 * Describes the message lvdr.v2.research.ResearchDiagramsResponse.
 * Use `create(ResearchDiagramsResponseSchema)` to create a new message.
 */
export const ResearchDiagramsResponseSchema: GenMessage<ResearchDiagramsResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 62);

/**
 * PinDiagramToReportRequest is the chat-flow → report bridge. `anchor_passage`
 * is the substring of the report markdown the chat tool cited (used by the
 * patcher to locate the insert point); `scroll_section` is the FE's currently-
 * viewed section heading and is consulted only when `anchor_passage` does
 * not match.
 *
 * @generated from message lvdr.v2.research.PinDiagramToReportRequest
 */
export type PinDiagramToReportRequest = Message<"lvdr.v2.research.PinDiagramToReportRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;

  /**
   * @generated from field: string anchor_passage = 3;
   */
  anchorPassage: string;

  /**
   * @generated from field: string scroll_section = 4;
   */
  scrollSection: string;
};

/**
 * Describes the message lvdr.v2.research.PinDiagramToReportRequest.
 * Use `create(PinDiagramToReportRequestSchema)` to create a new message.
 */
export const PinDiagramToReportRequestSchema: GenMessage<PinDiagramToReportRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 63);

/**
 * @generated from message lvdr.v2.research.PinDiagramToReportResponse
 */
export type PinDiagramToReportResponse = Message<"lvdr.v2.research.PinDiagramToReportResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error_reason = 2;
   */
  errorReason: string;

  /**
   * updated diagram (status=pinned, anchor stamped)
   *
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 3;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.PinDiagramToReportResponse.
 * Use `create(PinDiagramToReportResponseSchema)` to create a new message.
 */
export const PinDiagramToReportResponseSchema: GenMessage<PinDiagramToReportResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 64);

/**
 * DeleteDiagramRequest removes a diagram from the research. Registry row is
 * gone, and if the diagram was pinned its marker block is stripped from the
 * report markdown.
 *
 * @generated from message lvdr.v2.research.DeleteDiagramRequest
 */
export type DeleteDiagramRequest = Message<"lvdr.v2.research.DeleteDiagramRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;
};

/**
 * Describes the message lvdr.v2.research.DeleteDiagramRequest.
 * Use `create(DeleteDiagramRequestSchema)` to create a new message.
 */
export const DeleteDiagramRequestSchema: GenMessage<DeleteDiagramRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 65);

/**
 * @generated from message lvdr.v2.research.DeleteDiagramResponse
 */
export type DeleteDiagramResponse = Message<"lvdr.v2.research.DeleteDiagramResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error_reason = 2;
   */
  errorReason: string;
};

/**
 * Describes the message lvdr.v2.research.DeleteDiagramResponse.
 * Use `create(DeleteDiagramResponseSchema)` to create a new message.
 */
export const DeleteDiagramResponseSchema: GenMessage<DeleteDiagramResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 66);

/**
 * UnpinDiagramRequest reverses a pin: strips the marker block from the report
 * markdown, flips status from "pinned" → "draft", stamps unpinned_at, clears
 * pinned_at. Origin is preserved (history). The diagram returns to the draft
 * pool and may be re-pinned later via PinDiagramToReportRequest.
 *
 * @generated from message lvdr.v2.research.UnpinDiagramRequest
 */
export type UnpinDiagramRequest = Message<"lvdr.v2.research.UnpinDiagramRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;
};

/**
 * Describes the message lvdr.v2.research.UnpinDiagramRequest.
 * Use `create(UnpinDiagramRequestSchema)` to create a new message.
 */
export const UnpinDiagramRequestSchema: GenMessage<UnpinDiagramRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 67);

/**
 * @generated from message lvdr.v2.research.UnpinDiagramResponse
 */
export type UnpinDiagramResponse = Message<"lvdr.v2.research.UnpinDiagramResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error_reason = 2;
   */
  errorReason: string;

  /**
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 3;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.UnpinDiagramResponse.
 * Use `create(UnpinDiagramResponseSchema)` to create a new message.
 */
export const UnpinDiagramResponseSchema: GenMessage<UnpinDiagramResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 68);

/**
 * UpdateDiagramCaptionRequest mutates the caption field of an existing diagram.
 * For pinned diagrams the rendered caption inside the marker block is updated
 * in place. Empty caption strips the *<caption>* line. Length-capped server-
 * side at MaxCaptionLen (1024).
 *
 * @generated from message lvdr.v2.research.UpdateDiagramCaptionRequest
 */
export type UpdateDiagramCaptionRequest = Message<"lvdr.v2.research.UpdateDiagramCaptionRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;

  /**
   * @generated from field: string caption = 3;
   */
  caption: string;
};

/**
 * Describes the message lvdr.v2.research.UpdateDiagramCaptionRequest.
 * Use `create(UpdateDiagramCaptionRequestSchema)` to create a new message.
 */
export const UpdateDiagramCaptionRequestSchema: GenMessage<UpdateDiagramCaptionRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 69);

/**
 * @generated from message lvdr.v2.research.UpdateDiagramCaptionResponse
 */
export type UpdateDiagramCaptionResponse = Message<"lvdr.v2.research.UpdateDiagramCaptionResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error_reason = 2;
   */
  errorReason: string;

  /**
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 3;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.UpdateDiagramCaptionResponse.
 * Use `create(UpdateDiagramCaptionResponseSchema)` to create a new message.
 */
export const UpdateDiagramCaptionResponseSchema: GenMessage<UpdateDiagramCaptionResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 70);

/**
 * RegenerateDiagramRequest re-runs the generator on a single existing diagram
 * without re-running the detector or touching any other diagram. Empty
 * `generator` reuses the diagram's current generator; non-empty switches to
 * that generator. The diagram's existing stored fields (Intent, SourcePassage,
 * Caption, Kind) are used to synthesize an Opportunity for the generator;
 * AnchorText is not needed because the patcher replaces the existing marker
 * block by ID rather than re-anchoring against prose.
 *
 * @generated from message lvdr.v2.research.RegenerateDiagramRequest
 */
export type RegenerateDiagramRequest = Message<"lvdr.v2.research.RegenerateDiagramRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;

  /**
   * empty = keep current
   *
   * @generated from field: string generator = 3;
   */
  generator: string;
};

/**
 * Describes the message lvdr.v2.research.RegenerateDiagramRequest.
 * Use `create(RegenerateDiagramRequestSchema)` to create a new message.
 */
export const RegenerateDiagramRequestSchema: GenMessage<RegenerateDiagramRequest> = /*@__PURE__*/
  messageDesc(file_research_research, 71);

/**
 * @generated from message lvdr.v2.research.RegenerateDiagramResponse
 */
export type RegenerateDiagramResponse = Message<"lvdr.v2.research.RegenerateDiagramResponse"> & {
  /**
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string error_reason = 2;
   */
  errorReason: string;

  /**
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 3;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.RegenerateDiagramResponse.
 * Use `create(RegenerateDiagramResponseSchema)` to create a new message.
 */
export const RegenerateDiagramResponseSchema: GenMessage<RegenerateDiagramResponse> = /*@__PURE__*/
  messageDesc(file_research_research, 72);

/**
 * Lifecycle events fanned out to all subscribers of a research.
 *
 * @generated from message lvdr.v2.research.ResearchDiagramAddedEvent
 */
export type ResearchDiagramAddedEvent = Message<"lvdr.v2.research.ResearchDiagramAddedEvent"> & {
  /**
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 1;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchDiagramAddedEvent.
 * Use `create(ResearchDiagramAddedEventSchema)` to create a new message.
 */
export const ResearchDiagramAddedEventSchema: GenMessage<ResearchDiagramAddedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 73);

/**
 * @generated from message lvdr.v2.research.ResearchDiagramUpdatedEvent
 */
export type ResearchDiagramUpdatedEvent = Message<"lvdr.v2.research.ResearchDiagramUpdatedEvent"> & {
  /**
   * @generated from field: lvdr.v2.research.ResearchDiagram diagram = 1;
   */
  diagram?: ResearchDiagram | undefined;
};

/**
 * Describes the message lvdr.v2.research.ResearchDiagramUpdatedEvent.
 * Use `create(ResearchDiagramUpdatedEventSchema)` to create a new message.
 */
export const ResearchDiagramUpdatedEventSchema: GenMessage<ResearchDiagramUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 74);

/**
 * @generated from message lvdr.v2.research.ResearchDiagramRemovedEvent
 */
export type ResearchDiagramRemovedEvent = Message<"lvdr.v2.research.ResearchDiagramRemovedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string diagram_id = 2;
   */
  diagramId: string;
};

/**
 * Describes the message lvdr.v2.research.ResearchDiagramRemovedEvent.
 * Use `create(ResearchDiagramRemovedEventSchema)` to create a new message.
 */
export const ResearchDiagramRemovedEventSchema: GenMessage<ResearchDiagramRemovedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 75);

/**
 * @generated from message lvdr.v2.research.DiagramEnhancementJobUpdateEvent
 */
export type DiagramEnhancementJobUpdateEvent = Message<"lvdr.v2.research.DiagramEnhancementJobUpdateEvent"> & {
  /**
   * @generated from field: lvdr.v2.research.DiagramEnhancementJob job = 1;
   */
  job?: DiagramEnhancementJob | undefined;
};

/**
 * Describes the message lvdr.v2.research.DiagramEnhancementJobUpdateEvent.
 * Use `create(DiagramEnhancementJobUpdateEventSchema)` to create a new message.
 */
export const DiagramEnhancementJobUpdateEventSchema: GenMessage<DiagramEnhancementJobUpdateEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 76);

/**
 * ResearchReportRevisedEvent is emitted whenever the diagram patcher (or
 * PinExisting fallback) writes a new revision of the report markdown. The
 * FE listens for it and re-fetches the research result so chat-pin /
 * auto-enhancement edits show up without a manual refresh.
 *
 * Distinct from ResearchStatusUpdateEvent so exhaustive switches on the
 * status string don't see a synthetic "report_revised" value that conflates
 * engine lifecycle with diagram revisions.
 *
 * @generated from message lvdr.v2.research.ResearchReportRevisedEvent
 */
export type ResearchReportRevisedEvent = Message<"lvdr.v2.research.ResearchReportRevisedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: int32 revision = 2;
   */
  revision: number;
};

/**
 * Describes the message lvdr.v2.research.ResearchReportRevisedEvent.
 * Use `create(ResearchReportRevisedEventSchema)` to create a new message.
 */
export const ResearchReportRevisedEventSchema: GenMessage<ResearchReportRevisedEvent> = /*@__PURE__*/
  messageDesc(file_research_research, 77);

/**
 * CreditsState says WHY credits_spent is or is not a real number (BUG-11).
 * credits_known stays authoritative for the value itself: it is true iff
 * credits_state == CREDITS_STATE_KNOWN. Old clients read only credits_known.
 *
 * @generated from enum lvdr.v2.research.CreditsState
 */
export enum CreditsState {
  /**
   * not enriched (create/update/broadcast) or an older server
   *
   * @generated from enum value: CREDITS_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ledger lookup completed; credits_spent is real (0 included)
   *
   * @generated from enum value: CREDITS_STATE_KNOWN = 1;
   */
  KNOWN = 1,

  /**
   * enrichment ran and failed (ledger or org-lookup error)
   *
   * @generated from enum value: CREDITS_STATE_UNKNOWN = 2;
   */
  UNKNOWN = 2,

  /**
   * the viewer (session user) has no billable org — usage is not debited
   *
   * @generated from enum value: CREDITS_STATE_NOT_BILLED = 3;
   */
  NOT_BILLED = 3,

  /**
   * billing is not armed on this deployment
   *
   * @generated from enum value: CREDITS_STATE_BILLING_DISABLED = 4;
   */
  BILLING_DISABLED = 4,
}

/**
 * Describes the enum lvdr.v2.research.CreditsState.
 */
export const CreditsStateSchema: GenEnum<CreditsState> = /*@__PURE__*/
  enumDesc(file_research_research, 0);

